<template>
  <b-row>
    <b-col cols="12">
      <b-card title="FlyGate Portal Order user guide" class="background-color">
        <div style="position: relative; padding-bottom: 56.25%; height: 0;">
          <iframe
            src="https://jumpshare.com/embed/q4tTBeCLSPWxVX0xONnE"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
          ></iframe>
        </div>
      </b-card>

      <b-card title="FlyGate Portal Paid Transaction User Guide">
        <div style="position: relative; padding-bottom: 56.25%; height: 0;">
          <iframe
            src="https://jumpshare.com/embed/YpUfoXIaCseW4Pr0ZP1t"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
          ></iframe>
        </div>
      </b-card>

      <b-card title="FlyGate Portal Overall Transaction User Guide">
        <div style="position: relative; padding-bottom: 56.25%; height: 0;">
          <iframe
            src="https://jumpshare.com/embed/bFBuLdGEszBe1z4adyKU"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
          ></iframe>
        </div>
      </b-card>

      <b-card title="FlyGate Portal Market Share Report User Guide">
        <div style="position: relative; padding-bottom: 56.25%; height: 0;">
          <iframe
            src="https://jumpshare.com/embed/t0UVOiAIyAOzJ064U89A"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
          ></iframe>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BCard, BAlert, BLink, BCardText, BRow, BCol } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BAlert,
    BLink,
    BRow,
    BCol,
    BCardText,
  },
};
</script>

<style lang="scss">
.colors-list {
  li {
    padding: 0.4rem;
    svg {
      margin-right: 0.25rem;
    }
  }
}
</style>
